;(function() {
  'use strict'

  Rewards.$inject = ["$scope", "glError", "rewardsListService"];
  angular.module('app.rewards').controller('Rewards', Rewards)

  /* @ngInject */
  function Rewards($scope, glError, rewardsListService) {
    $scope.rewards = rewardsListService.get()
    $scope.rewards.promise.then(angular.noop, glError.fromStatus)
  }
})()
